import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import Input from '../../components/Input'
import OutlineButton from '../../components/OutlineButton'
import Text from '../../components/Text'
import patient from '../../stores/patient'

const Image = styled.img`
  width: 100%;
  max-height: 10rem;
  object-fit: contain;
  object-position: center;
  margin-bottom: 1rem;
`

const DeleteButton = styled.button`
  background: transparent;
  color: var(--gray);
  width: 100%;
  font-size: 0.9rem;
  transition: all 0.2s;
  cursor: pointer;
  padding: 0.5rem 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0 0 0;
  &:hover {
    color: var(--red);
  }
`

@observer
export default class ImageForm extends Component {
  render() {
    const { image, header } = this.props

    if (!patient.fields[image]) {
      return (
        <Fragment>
          <input
            type="file"
            style={{ display: 'none' }}
            id={`${image}-upload`}
            accept="image/*"
            name={image}
            onChange={event => patient.setImage(event.nativeEvent)}
          />
          <OutlineButton
            icon="fas fa-upload"
            str={header}
            onClick={() => document.querySelector(`#${image}-upload`).click()}
          />
        </Fragment>
      )
    }

    return (
      <Card>
        <Card.Title str={header} />
        <Card.Pad>
          <Image alt="" src={patient.fields[image]} />
          <Input
            label="titles.date"
            name={`${image}Date`}
            value={patient.fields[`${image}Date`]}
            onChange={patient.setField}
          />
          <DeleteButton onClick={() => patient.removeImage(image)}>
            <Text str="titles.remove" />
          </DeleteButton>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/ImageForm.js